// ** React Imports
import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom'

//reactstrap
import { Button } from 'reactstrap';

//img
import FailureImg from '../../../assets/images/failed-payment.png';

//scss
import './index.scss';

const FailurePage = () => {

    return (
        <div className="failure-page">
            
            <div className="container">
                <div className="failure-page__inner">
                    <div className='failure-page__img'>
                        <img src={FailureImg} alt="payment unsuccessful" />
                    </div>

                    <div className='failure-page__title'>
                        <h2 className='title'>Payment Unsuccessful</h2>
                        <p className='thank-note'>Please review your details and retry.</p>
                        <p className='thank-note'>Need assistance? Contact our support team. Thank you!</p>
                        <Button color='danger' tag={Link} to='/products-and-plans' block outline className='failure-btn mb-75'>
                            Try Again
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FailurePage;